<template>
  <CardExpand
    title="Ementa e Conteúdo"
    :expandido="true"
    class="my-4 custom-card"
    somente-icone
  >
    <v-row dense>
      <v-col>
        <div>
          <sds-input-control label="Ementa*:">
            <v-textarea
              aria-label="Ementa*:"
              hide-details
              outlined
              dense
              rows="2"
              class="mb-4"
              required
              v-model="parecerReferencial.deEmenta"
              data-testid="field-deEmenta"
            />
          </sds-input-control>
        </div>
      </v-col>
    </v-row>

    <v-row
      class="ma-0 pt-2 d-flex justify-start align-center"
      v-if="!arquivoEnviado"
    >
      <div class="custom-chip">
        <v-icon class="mr-2">mdi-alert-circle</v-icon>
        O arquivo do parecer é <span class="obrigatorio">obrigatório</span> e
        deverá estar no formato PDF.
      </div>
    </v-row>

    <v-row dense class="ma-0 mt-2 mb-2">
      <v-col cols="12" v-if="acceptExtensions">
        <SdsFileUpload
          v-model="listaArquivos"
          :accept="acceptExtensions"
          hide-download-button
          :max-files="1"
          :uploaded-files="arquivoEnviado ? [arquivoEnviado] : []"
          :hide-drop-zone="!!arquivoEnviado"
          @click:remove-uploaded-file="store.removerArquivo()"
        />
      </v-col>
    </v-row>
  </CardExpand>
</template>

<script lang="ts" setup>
import { storeToRefs } from 'pinia';
import { useCadastroParecerReferencialStore } from './../../store/CadastroParecerReferencialStore';
import SdsFileUpload from '@/components/sds-file-upload/SdsFileUpload.vue';
import CardExpand from '@/views/components/CardExpand.vue';

const store = useCadastroParecerReferencialStore();
const { parecerReferencial, acceptExtensions, listaArquivos, arquivoEnviado } =
  storeToRefs(store);
</script>
<style lang="scss" scoped>
.custom-card {
  margin-top: 20px;
}

.custom-chip {
  height: 60px;
  width: 100%;
  text-align: start;
  display: flex;
  align-items: center;
  padding: 10px;
  background-color: #f5f5f5;
  white-space: pre;
}

.obrigatorio {
  color: red;
  font-weight: bold;
}
</style>
